<label>Sub Category</label>
<ng-select
  [items]="filteredSubCategories"
  bindValue="id"
  bindLabel="sub_category"
  [(ngModel)]="value"
  (change)="onChange()"
  multiple="true"
  [loading]="subCategoryService.gettingRecords"
>
</ng-select>
